import { observable } from '@/libs/state'
import type { Customer } from './domain/customer'
import type { HistoryEntry } from '@/features/shared/domain/history'

const customerSearch$ = observable<string>('')
const customerEdit$ = observable<Customer | null>(null)
const customerList$ = observable<Customer[]>([])
const customerListVersion$ = observable<number>(0)
const customerHistory$ = observable<HistoryEntry[]>([])

const refreshCustomerList = () => customerListVersion$.set(v => v + 1)

export { customerSearch$, customerEdit$, customerList$, customerListVersion$, customerHistory$, refreshCustomerList }
